

export const openLink = (link, target = '_blank') => {
  let domLink = document.createElement('a');
  domLink.href = link;
  domLink.setAttribute('target', target);
  domLink.style.opacity = 0;
  domLink.style.zIndex = -999;
  document.body.appendChild(domLink);
  domLink.click();
  setTimeout(() => {
    document.body.removeChild(domLink);
  }, 200);
}

export const isMobile = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}


export function scrollIntoView(node, targetTop) {
  let myReq;
  const totalTime = 1000; // 耗时(毫秒)
  // 当前滚动高度
  let scrollTop = node.scrollTop;
  // 滚动step方法
  const step = function () {
    // 距离目标滚动距离
    let distance = targetTop - scrollTop;
    const diff = getDiff(distance);

    // 目标需要滚动的距离，也就是只走全部距离的五分之一
    scrollTop = scrollTop + diff;
    if (Math.abs(distance) < 1) {
      node.scrollTo(0, targetTop);
    } else {
      node.scrollTo(0, scrollTop);
      // setTimeout(step, 20);
      myReq = window.requestAnimationFrame(step);
    }
    // 判断滚动到时，取消定时
    if (Math.abs(targetTop - scrollTop) < 5) {
      window.cancelAnimationFrame(myReq);
    }
  };
  step();
}

function getDiff(distance) {
  if (distance < 100) {
    return distance / 14;  // 分母越大，单位时间内移动距离越小，速度越慢
  }
  if (distance < 300) {
    return distance / 12;
  }
  if (distance < 600) {
    return distance / 10;
  }
  return distance / 8;
}

export const SEND_DATE=`9月5日-9月25日`;
